/**
 * Controls how async confirm callbacks are handled by the dialog shell.
 *
 * - `immediate`: dialog closes right away; async callback value is passed unresolved.
 * - `await`: dialog waits for async callback resolution before closing.
 *
 * Sync callback results close immediately in both modes.
 */
export enum SharedDialogShellActionMode {
    IMMEDIATE = 'immediate',
    AWAIT = 'await',
}
